import { Link } from "react-router-dom";

const taskCards = [
  {
    type: "CrewAI Workflow",
    title: "运营 Listing 文案撰写",
    description: "提交结构化产品 Brief，由固定 Agent 协作生成关键词策略与 Listing 文案。",
    action: "开始撰写",
    to: "/listing-copywriting",
  },
  {
    type: "直接 Skill",
    title: "Amazon 报表集校验",
    description: "对已导入报表集执行确定性结构、覆盖、币种和单位校验。",
    action: "启动校验",
    to: "/execute/amazon-report-validate",
  },
  {
    type: "固定 Workflow",
    title: "亚马逊经营周报",
    description: "导入销售、流量、广告和库存报表，生成可追溯的经营周报。",
    action: "开始导入",
    to: "/weekly-report",
  },
  {
    type: "固定 Workflow",
    title: "供应链补货建议",
    description: "基于已发布公式计算下单时间、数量、物流方式与断货风险。",
    action: "创建补货任务",
    to: "/replenishment",
  },
  {
    type: "领域 Agent",
    title: "开放式运营分析",
    description: "由受限领域 Agent 在批准的 Skill 与 Workflow 范围内协助分析。",
    action: "新建分析",
    to: "/execute/amazon-operations-open-task",
  },
  {
    type: "领域 Agent",
    title: "开放式供应链分析",
    description: "在补货策略、证据和当前资源授权边界内规划供应链分析。",
    action: "新建分析",
    to: "/execute/supply-chain-open-task",
  },
  {
    type: "固定 Workflow",
    title: "受控商品图片试点",
    description: "登记来源权利，通过合规模型网关生成并人工选择图片候选。",
    action: "进入图片试点",
    to: "/images",
  },
  {
    type: "领域 Agent",
    title: "图片创意开放式任务",
    description: "在品牌、用途、成本和禁止自动发布边界内改进创意方案。",
    action: "新建创意任务",
    to: "/execute/image-creative-open-task",
  },
];

export function DashboardPage() {
  return (
    <div className="page-stack">
      <section className="hero-panel">
        <div>
          <span className="eyebrow">今日工作台</span>
          <h1>从业务任务开始，而不是从模型开始</h1>
          <p>
            选择固定流程或受限领域 Agent。所有数据访问、模型调用、Token 与产物均由平台统一治理。
          </p>
        </div>
        <div className="hero-stat">
          <strong>{taskCards.length}</strong>
          <span>一期业务入口</span>
        </div>
      </section>

      <section aria-labelledby="task-section-title">
        <div className="section-heading">
          <div>
            <span className="eyebrow">已发布能力</span>
            <h2 id="task-section-title">任务中心</h2>
          </div>
          <span className="phase-badge">一期框架</span>
        </div>

        <div className="task-grid">
          {taskCards.map((task) => (
            <article className="task-card" key={task.title}>
              <span className="task-type">{task.type}</span>
              <h3>{task.title}</h3>
              <p>{task.description}</p>
              <Link className="task-action" to={task.to}>
                {task.action}
              </Link>
            </article>
          ))}
        </div>
      </section>

      <section className="governance-panel" aria-label="平台治理摘要">
        <div>
          <strong>权限范围</strong>
          <span>部门、店铺、品牌、站点与数据集</span>
        </div>
        <div>
          <strong>执行模式</strong>
          <span>直接 Skill、固定 Workflow、领域 Agent</span>
        </div>
        <div>
          <strong>安全边界</strong>
          <span>只提供建议，不自动修改外部业务系统</span>
        </div>
      </section>
    </div>
  );
}
